import { Card, Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { BiRupee } from 'react-icons/bi';
import Api from '../function/axiosInterceptor';
const Donation_Grid = () => {
    var amt=0;
    const [user, getUser] = useState([]);
    useEffect(() => {
        Api.get('/admin/donation_grid').then((responce) => {
            if (responce.status == 1) {
                getUser(responce.data);
            }
        }).catch((error) => {
            console.error(error);
        });
    }, []);
    user && user.map((amiounts)=>{
        amt = amt + amiounts.amount;
    })
    return (<>
        <div className='d-flex justify-content-between mb-3'>
            <div className=''>
                <p className="text-muted mb-3">Total Amount :<code><BiRupee />{amt}.00</code>,
                    <span> Donation: <code>{user.length < 10 ? '0' + user.length : user.length}</code></span>
                </p>
            </div>
            <div>
                <Link to="/admin/donation-list"><button className='custom-btn'>Donation List</button></Link>
            </div>
        </div>
        <Row gutter={16}>
            {
                user && user.map((inf) => {
                    return (<>
                        <Col span={8}  className='mb-3'>
                            <Card title={`${inf.name} (${new Date(inf.createdAt).toUTCString().slice(4,17)})`} bordered={false}>
                                <div>{inf.phone} </div>
                                <div>{inf.email}</div>
                                <div>Amount : <BiRupee/>{Number(inf.totalDonation || 0).toFixed(2)},&nbsp; &nbsp;  Count : {Number(inf.numOfdonationm || 0).toString().padStart(2,'0')}</div>
                            </Card>
                        </Col>
                    </>)
                })
            }
        </Row>
    </>)
}
export default Donation_Grid;